"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-maria-la-fossa": {
    "07a6f0c0": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "camino": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6c1a626c": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "cavallerizza-nuova": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49c660d7": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "cavallerizze-vecchie": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19adf23e": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "la-torre": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa2cd4fc": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "mormili": [{
      "hkey": "0d7269b2",
      "slug": "santa-maria-la-fossa",
      "name": "Santa Maria la Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;